import React from 'react';
import { wrapComponent } from 'unitx-ui';
import { useNode } from "../../hooks";
import { calculateDisplayObjectBounds } from "../../utils";
import Container from "../Container";

function NodeContainer(props, __) {
  var _ref, _config$position;

  const {
    item,
    graphID,
    children,
    config = {}
  } = props;
  const containerRef = React.useRef(null);
  const {
    element,
    context
  } = useNode({
    id: item.id,
    graphID,
    config,
    position: (_ref = (_config$position = config.position) !== null && _config$position !== void 0 ? _config$position : item.position) !== null && _ref !== void 0 ? _ref : {
      x: 0,
      y: 0
    },
    onPositionChange: ({
      element
    }) => {
      const {
        x,
        y
      } = element.position(); // @ts-ignore

      containerRef.current.x = x; // @ts-ignore

      containerRef.current.y = y;
      context.boundingBox.x = x;
      context.boundingBox.y = y;
    }
  });
  const {
    x,
    y
  } = element.position();
  const onDrag = React.useCallback(pos => {
    element.position(pos);
  }, [element]);
  React.useEffect(() => {
    // @ts-ignore
    context.boundingBox = calculateDisplayObjectBounds(containerRef.current);
  });
  return /*#__PURE__*/React.createElement(Container, {
    ref: containerRef,
    style: {
      left: x,
      top: y
    },
    draggable: true,
    onDrag: onDrag // onRightPress={(event) => {
    //   console.log('rightPress')
    //   event.data.originalEvent.preventDefault()
    //   event.data.originalEvent.stopPropagation()
    // }}
    // onPress={(e) => console.log('press')}

  }, children({
    item,
    element
  }));
}

export default wrapComponent(NodeContainer, {
  isForwardRef: true
});